__turbopack_context__.v({
  "discordIcon": "TpIA3W_discordIcon",
  "dropdown": "TpIA3W_dropdown",
  "dropdownContent": "TpIA3W_dropdownContent",
  "dropdownItem": "TpIA3W_dropdownItem",
  "userDropdownButton": "TpIA3W_userDropdownButton",
});
